import { render, staticRenderFns } from "./RateModal.vue?vue&type=template&id=07b4e079"
import script from "./RateModal.vue?vue&type=script&lang=js"
export * from "./RateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports